"use client";
import { Button } from "@/components/ui/button";
import {
  MessageSquare, BookOpen, Activity, FileText, HelpCircle, ExternalLink,
} from "lucide-react";
import { useTranslation } from "react-i18next";

const Support = () => {
  const { t } = useTranslation();

  const quickLinks = [
    { title: String(t("support.contactSupport")), desc: String(t("support.openTicket")), action: String(t("support.newTicket")) },
    { title: String(t("support.statusPage")), desc: String(t("support.platformHealth")), action: String(t("support.viewStatus")) },
    { title: String(t("support.releaseNotes")), desc: String(t("support.latestUpdates")), action: String(t("support.viewNotes")) },
  ];

  const commonIssues = [
    { q: String(t("support.q1")), a: String(t("support.a1")) },
    { q: String(t("support.q2")), a: String(t("support.a2")) },
    { q: String(t("support.q3")), a: String(t("support.a3")) },
    { q: String(t("support.q4")), a: String(t("support.a4")) },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{String(t("support.title"))}</h1>
        <p className="text-sm text-muted-foreground mt-1">{String(t("support.subtitle"))}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickLinks.map((item, idx) => (
          <div key={String(item.title)} className="rounded-lg border border-border/50 bg-card p-5 shadow-sm flex flex-col">
            <div className="flex items-center gap-2 mb-2">
              {idx === 0 && <MessageSquare className="h-4 w-4 text-muted-foreground" />}
              {idx === 1 && <Activity className="h-4 w-4 text-muted-foreground" />}
              {idx === 2 && <FileText className="h-4 w-4 text-muted-foreground" />}
              <h3 className="text-sm font-medium">{item.title}</h3>
            </div>
            <p className="text-xs text-muted-foreground mb-4">{String(item.desc)}</p>
            <Button variant="outline" size="sm" className="mt-auto gap-1.5 w-fit">
              <span>{String(item.action)}</span>
              <ExternalLink className="h-3 w-3" />
            </Button>
          </div>
        ))}
      </div>

      <div className="rounded-lg border border-border/50 bg-card p-5 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <HelpCircle className="h-4 w-4 text-muted-foreground" />
          <h3 className="text-sm font-medium">{String(t("support.commonIssues"))}</h3>
        </div>
        <div className="space-y-4">
          {commonIssues.map((item, i) => (
            <div key={i} className="border-b border-border/30 last:border-0 pb-4 last:pb-0">
              <p className="text-sm font-medium mb-1">{item.q}</p>
              <p className="text-sm text-muted-foreground">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Support;
